// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"78bb2bd5","192":"8f6f033b","332":"58d94c5a","367":"88d9503b","395":"c181f225","408":"4c7a9dfe","723":"51d59157","989":"d2fb8348","993":"ab126b99"}[chunkId] + ".chunk.js";
};